import React from 'react';
import { stringify } from 'rebem-classname';

export default function IngresarDesplegable(props){
	const block = "ingresar";

    const getApp = window.location.hostname == "app.alquilerargentina.com" ? "&app=1" : ""
    let urlAnfitrion = "https://login.alquilerargentina.com?ingreso=anfitrion" + getApp;
    // si esta logueado y es tipo anfitrion se le agrega la url de clientes para que vaya a su pdc
    if(props.turista && props.turista.tipo == 0){
        urlAnfitrion = "https://clientes.alquilerargentina.com/";
    }

    return(		
        <div className={stringify({block, mods:{noFix:props.noFix}})}>
            <div className={stringify({block, elem:"opciones-container"})}>
                <a href={"https://login.alquilerargentina.com?ingreso=turista" + getApp} target="_blank" className={stringify({block,elem:"opciones"})}>Ingresar como Turista</a>
                <a href={urlAnfitrion} target="_blank" className={stringify({block,elem:"opciones"})}>Ingresar como Anfitrión</a>
            </div>
        </div>
    );
}